import React, {Component} from 'react'

import {AppWrapper, FunnelPage} from '@influxdata/clockface'
import {HoneybadgerErrorBoundary} from '@honeybadger-io/react'

import HBContext from 'js/honeyBadgerContext.js'
import LogoWithCubo from 'js/components/LogoWithCubo'

import SignUpPageContents, {SignupError} from './SignUpPageContents'
import {Marketplace} from 'js/types/marketplace'
import FunnelSubHeader from '../shared/FunnelSubheader'
import FunnelHeader from '../shared/FunnelHeader'
import {SocialFocus} from './SocialFocusedSignup'

interface Props {
  marketplace: Marketplace
}

class SignUp extends Component<Props> {
  static contextType = HBContext
  render() {
    return (
      <HoneybadgerErrorBoundary honeybadger={this.context}>
        <AppWrapper type="funnel">
          <FunnelPage enableGraphic={true} logo={<LogoWithCubo />}>
            <FunnelHeader text="Set Up Your InfluxData Account" />
            <FunnelSubHeader
              text={`Create a login to activate your ${this.marketplaceName} Marketplace
              subscription.`}
            />
            <SignUpPageContents
              marketplaceName={this.marketplaceName}
              socialFocus={this.socialFocus}
              signupError={this.signupError}
            />
          </FunnelPage>
        </AppWrapper>
      </HoneybadgerErrorBoundary>
    )
  }

  private get signupError(): SignupError {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('exists')) {
      return {type: 'existingUser', additional: urlParams.get('exists')}
    }

    if (urlParams.has('error')) {
      return {type: 'generic'}
    }
  }

  private get socialFocus(): SocialFocus {
    if (this.props.marketplace === 'azure') {
      return 'microsoft'
    }
  }

  private get marketplaceName() {
    switch (this.props.marketplace) {
      case 'aws':
        return 'AWS'
      case 'azure':
        return 'Microsoft Azure'
      case 'gcm':
        return 'Google Cloud'
      default:
        return ''
    }
  }
}

export default SignUp
